import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/fe/src/components/containers/catalog/series/series-by-id-container.tsx");
